import React from 'react';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

import Raven from 'raven-js';

import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router, Route, IndexRoute, browserHistory, Redirect} from 'react-router';
import {syncHistoryWithStore} from 'react-router-redux';

import configureStore from './store';

import AppContainer from './containers/app-container';
import HomeContainer from './containers/home-container';

import AdminContainer from './containers/admin/admin-container';
import LoginContainer from './containers/admin/login-container';

import DashboardContainer from './containers/admin/dashboard-container';
import UsersContainer from './containers/admin/users/users-container';
import UserContainer from './containers/admin/users/user-container';

import SeasonsContainer from './containers/admin/season/seasons-container';
import SeasonContainer from './containers/admin/season/season-container';

import PartnersContainer from './containers/admin/partner/partners-container';
import PartnerContainer from './containers/admin/partner/partner-container';
import PartnersPageContainer from './containers/pages/partners-page-container';

import StagesContainer from './containers/admin/stage/stages-container';
import StageContainer from './containers/admin/stage/stage-container';
import StageResultsContainer from './containers/admin/stage/stage-results-container';

import StagesPageContainer from './containers/pages/stages-page-container';
import StageRegulationsPageContainer from './containers/pages/stage-regulations-page-container';
import StageRegistrationPageContainer from './containers/pages/stage-registration-page-container';
import StageParticipantsPageContainer from './containers/pages/stage-participants-page-container';
import StageResultsPageContainer from './containers/pages/stage-results-page-container';

import PostPageContainer from './containers/pages/post-page-container';

import ParticipantPageContainer from './containers/pages/participant-page-container';
import AdminParticipantsContainer from './containers/admin/participant/participants-container';
import AdminParticipantContainer from './containers/admin/participant/participant-container';

import ExportPageContainer from './containers/admin/export/export-container';

import AdminPostsContainer from './containers/admin/post/posts-container';
import AdminPostContainer from './containers/admin/post/post-container';
import PostsPageContainer from './containers/pages/posts-page-container';
import SettingsContainer from './containers/admin/settings/settings-container';
import ConfigurationContainer from './containers/admin/settings/configuration-container';
import PaymentCanceledPageContainer from './containers/pages/payment-canceled-page-container';
import AboutPageContainer from './containers/pages/about-page-container';
import ContactsPageContainer from './containers/pages/contacts-page-container';
import ResultsPageContainer from './containers/pages/results-page-container';
import RegulationsPageContainer from './containers/pages/regulations-page-container';
import InsurancePageContainer from './containers/pages/insurance-page-container';
import ArchivePageContainer from './containers/pages/archive-page-container';

import ParticipantResultsContainer from './containers/pages/participant-results-page-container';
import ParticipantResultsV2Container from './containers/pages/participant-results-v2-page-container';
import AdminImagesContainer from './containers/admin/image/images-container';
import AdminImageContainer from './containers/admin/image/image-container';
import AdminParticipantResultsContainer from './containers/admin/participant-results/participant-results-container';
import AdminParticipantResultContainer from './containers/admin/participant-results/participant-result-container';

import PartnerCategoriesContainer from './containers/admin/partner-category/partner-categories-container';
import PartnerCategoryContainer from './containers/admin/partner-category/partner-category-container';
import GdprPageContainer from './containers/pages/gdpr-page-container';


import AdminPromoCodesContainer from './containers/admin/promo-codes/promo-codes-container';
import AdminPromoCodeContainer from './containers/admin/promo-codes/promo-code-container';

import AdminInvoicesContainer from './containers/admin/invoices/invoices-container';
import AdminInvoiceContainer from './containers/admin/invoices/invoice-container';

import AdminPagesContainer from './containers/admin/page/pages-container';
import AdminPageContainer from './containers/admin/page/page-container';

import 'react-select/dist/react-select.min.css';
import '../style/index.styl';
import SeasonStagesPageContainer from './containers/pages/season-stages-page-container';
import PagePageContainer from './containers/pages/page-page-container';
import StageParticipantsUploadContainer from './containers/admin/stage/stage-participants-upload-container';

const store = configureStore();

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store);

function requireAuth(nextState, replace) {
    if (!window.USER_LOGGED) {
        replace({
            pathname: '/login',
            state: {
                nextPathname: nextState.location.pathname
            }
        });
    }
}

if (window.CARE_CONFIG.settings.google_analytics_code && window.CARE_CONFIG.settings.google_analytics_code.length) {
    ReactGA.initialize(window.CARE_CONFIG.settings.google_analytics_code);

}

if (window.CARE_CONFIG.settings.fb_pixel_code && window.CARE_CONFIG.settings.fb_pixel_code.length) {
    const advancedMatching = { };
    const options = {
        autoConfig: true, 	// set pixel's autoConfig
        debug: false 		// enable logs
    };
    ReactPixel.init(window.CARE_CONFIG.settings.fb_pixel_code, advancedMatching, options);
}

function fireTracking() {
    if (window.CARE_CONFIG.settings.google_analytics_code && window.CARE_CONFIG.settings.google_analytics_code.length) {
        ReactGA.pageview(window.location.pathname);
    }
    if (window.CARE_CONFIG.settings.fb_pixel_code && window.CARE_CONFIG.settings.fb_pixel_code.length) {
        ReactPixel.pageView(window.location.pathname);
    }
}

if (window.CARE_CONFIG.trackErrors) {
    Raven.config('https://3e635e27f4996e983b5bd9659ed6d751@o4507571029540864.ingest.de.sentry.io/4508443031830608').install();
}

ReactDOM.render(
    <Provider store={store}>
        <Router history={history} onUpdate={fireTracking}>
            <Route path="/" component={AppContainer}>
                <IndexRoute component={HomeContainer}/>
                <Route path="stages">
                    <IndexRoute component={StagesPageContainer}/>
                    <Route path=":seasonId" component={SeasonStagesPageContainer}/>
                    <Route path=":itemId/regulations" component={StageRegulationsPageContainer}/>
                    <Route path=":itemId/registration" component={StageRegistrationPageContainer}/>
                    <Route path=":itemId/participants" component={StageParticipantsPageContainer}/>
                    <Route path=":itemId/results" component={StageResultsPageContainer}/>

                </Route>
                <Route path="participant">
                    <Route path=":itemUuid" component={ParticipantPageContainer}/>
                </Route>

                <Route path="insurance" component={InsurancePageContainer}/>
                <Route path="archive" component={ArchivePageContainer}/>
                <Route path="regulations" component={RegulationsPageContainer}/>
                <Route path="about" component={AboutPageContainer}/>
                <Route path="results" component={ResultsPageContainer}/>
                <Route path="partners" component={PartnersPageContainer}/>
                <Route path="contact" component={ContactsPageContainer}/>
                <Route path="participant-results" component={ParticipantResultsContainer}/>
                <Route path="participant-results/:resultId" component={ParticipantResultsV2Container}/>
                <Route path="gdpr" component={GdprPageContainer}/>

                <Route path="post/:slug" component={PostPageContainer}/>
                <Route path="page/:slug" component={PagePageContainer}/>

                <Route path="payment-canceled" component={PaymentCanceledPageContainer}/>
                <Route path="posts">
                    <IndexRoute component={PostsPageContainer}/>
                    <Route path="page/:page" component={PostsPageContainer}/>
                </Route>
            </Route>

            <Route path="login" component={LoginContainer}/>
            <Route path="admin" component={AdminContainer} onEnter={requireAuth}>

                <IndexRoute component={DashboardContainer}/>
                <Route path="users">
                    <IndexRoute component={UsersContainer}/>
                    <Route path=":itemId" component={UserContainer}/>
                </Route>
                <Route path="seasons">
                    <IndexRoute component={SeasonsContainer}/>
                    <Route path=":itemId" component={SeasonContainer}/>
                </Route>

                <Route path="partners">
                    <IndexRoute component={PartnersContainer}/>
                    <Route path=":itemId" component={PartnerContainer}/>
                </Route>
                <Route path="partner-categories">
                    <IndexRoute component={PartnerCategoriesContainer}/>
                    <Route path=":itemId" component={PartnerCategoryContainer}/>
                </Route>

                <Route path="participants">
                    <IndexRoute component={AdminParticipantsContainer}/>
                    <Route path=":itemId" component={AdminParticipantContainer}/>
                </Route>
                <Route path="participant-results">
                    <IndexRoute component={AdminParticipantResultsContainer}/>
                    <Route path=":itemId" component={AdminParticipantResultContainer}/>
                </Route>
                <Route path="images">
                    <IndexRoute component={AdminImagesContainer}/>
                    <Route path=":itemId" component={AdminImageContainer}/>
                </Route>

                <Route path="promo-codes">
                    <IndexRoute component={AdminPromoCodesContainer}/>
                    <Route path=":itemId" component={AdminPromoCodeContainer}/>
                </Route>
                <Route path="invoices">
                    <IndexRoute component={AdminInvoicesContainer}/>
                    <Route path=":itemId" component={AdminInvoiceContainer}/>
                </Route>

                <Route path="posts">
                    <IndexRoute component={AdminPostsContainer}/>
                    <Route path=":itemId" component={AdminPostContainer}/>
                </Route>
                <Route path="pages">
                    <IndexRoute component={AdminPagesContainer}/>
                    <Route path=":itemId" component={AdminPageContainer}/>
                </Route>
                <Route path="export" component={ExportPageContainer}/>

                <Route path="stages">
                    <IndexRoute component={StagesContainer}/>
                    <Route path=":itemId" component={StageContainer}/>
                    <Route path=":itemId/results" component={StageResultsContainer}/>
                    <Route path=":itemId/participants-upload" component={StageParticipantsUploadContainer}/>

                </Route>
                <Route path="settings" component={SettingsContainer}/>
                <Route path="config" component={ConfigurationContainer}/>
            </Route>
            <Redirect from="*" to="/"/>
        </Router>
    </Provider>, document.getElementById('mount'))



// WEBPACK FOOTER //
// ./src/js/index.js